import { inject, Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { ENV } from '../../core-ng/injection-token';

@Injectable({ providedIn: 'root' })
export class SupabaseClientService {
  private supabase: SupabaseClient;

  environment = inject(ENV);

  constructor() {
    this.supabase = createClient(
      this.environment.supabaseUrl,
      this.environment.supabaseAnonKey,
      {
        auth: {
          persistSession: true, // Set true to keep the user logged in
          autoRefreshToken: false, // avoids NavigatorLock issues
        },
      }
    );
  }
  get client() {
    return this.supabase;
  }
}
